export const CHECKOUT_URL = 'https://decisionclinica.impultienda.ar/checkout/diabetes'

export const IMAGES = {
  bundle: 'https://cdn.magicpatterns.com/uploads/8BzVUQC6nBKZP4ZyfqWEmS/DIABETES.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/nqhygFSa8tMMBqno7SZ15A/BONO_1_DIABETES.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/aw3HBkQ2wD7VfdRSqmZX5r/BONO_2_DIABETES.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/wX895hfEXvgbo6D9ZCVm2c/BONO_3_DIABETES.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/hScrXxfuRgidvrJgp6f6vV/BONO_4_DIABETES.png',
  bono5: 'https://cdn.magicpatterns.com/uploads/jiN3JQmJyuRXRdvKGr9asg/BONO_5_DIABETES.png',
  karito: 'https://cdn.magicpatterns.com/patterns/generated-images/3184ad2a-0c13-44f0-ba0e-8fd32c43986b.jpg',
}

export const stats = [
  { value: '+300', label: 'Algoritmos listos' },
  { value: '+2.000', label: 'Médicos confían' },
  { value: '2 min', label: 'Por paciente' },
  { value: '99%', label: 'Lo recomiendan' },
]

export const clinicalDoubts = [
  '¿Mantengo metformina o ya debo intensificar?',
  '¿Es mejor un arGLP-1 o un iSGLT2?',
  '¿Debo iniciar insulina ahora o todavía puedo esperar?',
  '¿Qué hago si además tiene enfermedad renal?',
  '¿Y si también tiene insuficiencia cardíaca?',
  '¿Estoy siguiendo realmente las recomendaciones más recientes?',
]

export const systemStages = [
  'Diagnóstico',
  'Tratamiento inicial',
  'Intensificación',
  'Protección cardiovascular',
  'Protección renal',
  'Insulinización',
  'Seguimiento',
]

export const beforeItems = [
  'Revisabas varias guías para confirmar una decisión.',
  'Dudabas entre varias opciones terapéuticas.',
  'Evitabas iniciar insulina por inseguridad.',
  'Los pacientes complejos consumían gran parte de tu consulta.',
  'Temías pasar por alto recomendaciones importantes.',
]

export const afterItems = [
  'Sigues un algoritmo claro desde el diagnóstico hasta el seguimiento.',
  'Seleccionas el tratamiento según el perfil del paciente.',
  'Tomas decisiones con mayor rapidez y consistencia.',
  'Manejas con confianza pacientes con enfermedad renal o riesgo cardiovascular.',
  'Llegas a cada consulta con un sistema listo para aplicar.',
]

export const identifyItems = [
  'Tienes un paciente frente a ti y dudas entre indicar un arGLP-1, un iSGLT2 o iniciar insulina.',
  'Inviertes demasiado tiempo revisando ADA, EASD o KDIGO para confirmar una decisión.',
  'Los pacientes con múltiples comorbilidades hacen que cada consulta sea más compleja.',
  'Sientes que tus decisiones dependen más de la memoria que de un proceso estructurado.',
  'Te preocupa olvidar un examen o un ajuste importante durante el seguimiento.',
  'Quisieras tener un método claro que puedas aplicar en cualquier consulta, sin improvisar.',
]

export interface Tomo {
  number: string
  title: string
  promise: string
  intro: string
  bullets: string[]
}

export const tomos: Tomo[] = [
  {
    number: '1',
    title: 'El Diagnóstico Sin Dudas',
    promise:
      'Aprende a identificar con precisión quién tiene diabetes, quién está en riesgo y quién necesita un enfoque completamente diferente.',
    intro: 'Al finalizar este tomo podrás:',
    bullets: [
      'Diagnosticar con seguridad desde la primera consulta.',
      'Diferenciar diabetes tipo 2, LADA y MODY sin confusiones.',
      'Evitar errores diagnósticos que retrasan el tratamiento.',
      'Aplicar los criterios actuales sin tener que consultar múltiples guías.',
    ],
  },
  {
    number: '2',
    title: 'El Tratamiento Correcto Desde el Primer Día',
    promise:
      'Elige la mejor estrategia terapéutica para cada paciente y evita empezar con el tratamiento equivocado.',
    intro: 'Aprenderás a:',
    bullets: [
      'Definir objetivos personalizados de HbA1c.',
      'Elegir el tratamiento inicial con seguridad.',
      'Saber exactamente cuándo intensificar.',
      'Adaptar la terapia según el perfil de cada paciente.',
    ],
  },
  {
    number: '3',
    title: 'Protege el Corazón Mientras Controlas la Glucosa',
    promise:
      'Aprende cuándo utilizar iSGLT2 y arGLP-1 para ofrecer mucho más que control glucémico.',
    intro: 'Descubrirás cómo:',
    bullets: [
      'Reducir el riesgo cardiovascular.',
      'Elegir el medicamento correcto según el perfil clínico.',
      'Aplicar ADA y ESC sin complicaciones.',
      'Proteger órganos diana desde etapas tempranas.',
    ],
  },
  {
    number: '4',
    title: 'Preserva la Función Renal con Cada Decisión',
    promise: 'Maneja pacientes con enfermedad renal sin miedo a cometer errores terapéuticos.',
    intro: 'Podrás:',
    bullets: [
      'Ajustar medicamentos según la TFG.',
      'Evitar toxicidad por dosis incorrectas.',
      'Aplicar KDIGO de forma práctica.',
      'Proteger la función renal mientras optimizas el tratamiento.',
    ],
  },
  {
    number: '5',
    title: 'Domina la Insulina Sin Miedo',
    promise: 'Convierte una de las decisiones más complejas en un proceso claro y reproducible.',
    intro: 'Aprenderás a:',
    bullets: [
      'Saber cuándo iniciar insulina.',
      'Titular dosis con seguridad.',
      'Evitar hipoglucemias.',
      'Ajustar tratamientos según la evolución del paciente.',
    ],
  },
  {
    number: '6',
    title: 'Controla la Diabetes a Largo Plazo',
    promise:
      'Implementa un seguimiento estructurado que reduzca complicaciones y mejore los resultados clínicos.',
    intro: 'Serás capaz de:',
    bullets: [
      'Manejar adultos mayores y pacientes complejos.',
      'Detectar complicaciones oportunamente.',
      'Organizar el seguimiento anual.',
      'Mantener el control de cada paciente con un sistema claro.',
    ],
  },
]

export interface Bono {
  number: string
  title: string
  description: string
  value: string
  image?: string
}

export const bonos: Bono[] = [
  {
    number: '1',
    title: 'Vademécum Inteligente de Ajuste Renal',
    description:
      'Prescribe con seguridad en pacientes con enfermedad renal utilizando una tabla visual de colores que te permite ajustar medicamentos en segundos.',
    value: 'USD $27',
    image: IMAGES.bono1,
  },
  {
    number: '2',
    title: 'Sistema Express de Inicio y Titulación de Insulina',
    description: 'Protocolos listos para iniciar, cambiar y ajustar insulina sin improvisar.',
    value: 'USD $37',
    image: IMAGES.bono2,
  },
  {
    number: '3',
    title: 'Checklist Maestro del Control Anual',
    description: 'Nunca vuelvas a olvidar un examen importante durante el seguimiento de tus pacientes.',
    value: 'USD $27',
    image: IMAGES.bono3,
  },
  {
    number: '4',
    title: 'Guion Clínico para Vencer el Miedo a la Insulina',
    description: 'Aprende exactamente qué decir cuando un paciente rechaza el tratamiento.',
    value: 'USD $20',
    image: IMAGES.bono4,
  },
  {
    number: '5',
    title: 'Mapa Rápido de Interacciones Terapéuticas',
    description:
      'Detecta en segundos los medicamentos que alteran el control glucémico antes de que generen problemas.',
    value: 'USD $29',
    image: IMAGES.bono5,
  },
]

export interface Testimonial {
  quote: string
  name: string
  location: string
  flag: string
  image: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Ahora entro a la consulta con un método claro. Ya no pierdo tiempo buscando recomendaciones en varias guías.',
    name: 'María P.',
    location: 'Colombia',
    flag: '🇨🇴',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/11936806-e017-4b07-9b24-6a445851a639.jpg',
  },
  {
    quote: 'El módulo de enfermedad renal cambió por completo mi forma de ajustar tratamientos.',
    name: 'Roberto L.',
    location: 'México',
    flag: '🇲🇽',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ead7109a-e5c8-4f3d-8371-9c311862aec2.jpg',
  },
  {
    quote: 'Solo el algoritmo de insulinización vale varias veces el precio del sistema.',
    name: 'Carolina G.',
    location: 'Argentina',
    flag: '🇦🇷',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/34b7d32e-6945-4255-8667-8c30baa03cc3.jpg',
  },
]

export const faqs = [
  {
    question: '¿Cómo recibiré el sistema?',
    answer:
      'Recibirás acceso inmediato para descargar todos los materiales en formato digital una vez confirmado tu pago.',
  },
  {
    question: '¿Funciona para cualquier país?',
    answer:
      'Sí. Está basado en recomendaciones internacionales ampliamente utilizadas y puede aplicarse en la práctica clínica de cualquier país hispanohablante, respetando siempre la normativa y disponibilidad de tratamientos locales.',
  },
  {
    question: '¿Necesito ser especialista?',
    answer:
      'No. El contenido está diseñado para médicos que atienden pacientes con diabetes y buscan un sistema práctico para apoyar sus decisiones clínicas.',
  },
  {
    question: '¿Debo pagar nuevamente?',
    answer: 'No. Realizas un único pago y el acceso es tuyo de forma permanente.',
  },
  {
    question: '¿Puedo consultarlo desde el celular?',
    answer:
      'Sí. Podrás acceder al material desde computadora, tablet o teléfono cuando lo necesites.',
  },
]

export const recentBuyers = [
  { name: 'Dra. Valentina R.', country: 'Chile' },
  { name: 'Dr. Andrés M.', country: 'Colombia' },
  { name: 'Dra. Lucía F.', country: 'España' },
  { name: 'Dr. Javier T.', country: 'México' },
  { name: 'Dra. Camila S.', country: 'Argentina' },
  { name: 'Dr. Miguel A.', country: 'Perú' },
  { name: 'Dra. Fernanda O.', country: 'Ecuador' },
  { name: 'Dr. Rodrigo V.', country: 'Uruguay' },
  { name: 'Dra. Paola C.', country: 'Guatemala' },
  { name: 'Dr. Esteban L.', country: 'Costa Rica' },
  { name: 'Dra. Daniela H.', country: 'Bolivia' },
  { name: 'Dr. Sergio N.', country: 'Panamá' },
  { name: 'Dra. Isabel Q.', country: 'República Dominicana' },
  { name: 'Dr. Tomás B.', country: 'Paraguay' },
  { name: 'Dra. Gabriela E.', country: 'Venezuela' },
]
